import { Box } from '@mui/material';
import type { Entity, Job } from '../../../core/types/data-models';
import { ManagedKnowledgeOverviewSection } from './ManagedKnowledgeOverviewSection';
import { MarketRadarSection } from './MarketRadarSection';

/** Height cap for the row — each block scrolls its own body. */
const ROW_MAX_HEIGHT = 550;

interface KeyEntitiesRadarRowProps {
  projectId: number;
  /** The project's PENDING/PROCESSING jobs, already polled by the page. */
  activeJobs: Job[];
  onOpenEntity: (entity: Entity) => void;
  /** A card for every entity type extracted for the project rather than for the managed ones. */
  allEntityTypes?: boolean;
}

/**
 * Key entities (2/3) beside the market radar (1/3); they stack on narrow
 * viewports. Both panels are grid items capped at the same height, so the
 * row can't grow past it and the shorter panel stretches to match — each
 * then scrolls its own body. Shown on the project dashboard and at the end
 * of an idea validation's summary.
 */
export function KeyEntitiesRadarRow({ projectId, activeJobs, onOpenEntity, allEntityTypes }: KeyEntitiesRadarRowProps) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', lg: 'minmax(0, 2fr) minmax(0, 1fr)' },
        gap: 3,
      }}
    >
      <ManagedKnowledgeOverviewSection
        projectId={projectId}
        activeJobs={activeJobs}
        onOpenEntity={onOpenEntity}
        maxHeight={ROW_MAX_HEIGHT}
        allEntityTypes={allEntityTypes}
      />
      <MarketRadarSection projectId={projectId} activeJobs={activeJobs} maxHeight={ROW_MAX_HEIGHT} />
    </Box>
  );
}
